import React, { useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_GIVEAWAYS } from 'queries/queries';
import arrowIcon from '../../assets/images/arrow_left_icon.png';
import { useHistory } from "react-router-dom";
import backArrow from '../../assets/images/left_arrow.png';

const GiveawayList = () => {
  const { loading, error, data } = useQuery(GET_GIVEAWAYS, {
    fetchPolicy: "no-cache",
  });

  const giveaways = data?.getGiveaways || [];
  const history = useHistory();


  useEffect(() => {
    const wrapper = document.querySelector(".scrollable");
    if (!wrapper) return;
  
    document.querySelector(".scrollable").addEventListener(
      "touchmove",
      function(event) {
        event.stopPropagation();
      },
      false
    );
  });


  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error loading giveaways.</p>;


  const handleBack = () => {
    history.goBack() 
  };

  return (
    <div className="hcp-portals scrollable">
      <div className="points-header">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <div className="points-header-title">Gewinnspiele</div>
        <div className="points-header-empty"></div>
      </div>

      <div 
        className="portals-list" 
        style={{ paddingTop: '20px' }}
      >
        {giveaways.map((giveaway, i) => {
          const shortDescription =
            giveaway.description?.length > 120
              ? giveaway.description.slice(0, 120) + "…"
              : giveaway.description;

          return (
            <div className="portal-card" key={i} onClick={() => history.push(`/giveaway/${giveaway.id}`)}>
              <div className="content">
                <h3>{giveaway.name}</h3>
                <p>{shortDescription}</p>
              </div>
              <div className="arrow">
                <img src={arrowIcon} alt="arrow" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default GiveawayList;